import "./Contact.css";
import siteData from "../data/siteData.json";
import { useState } from "react";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      user_name: formData.name,
      user_phone: formData.phone,
      user_email: formData.email,
      message: formData.message,
    };

    emailjs
      .send(
        "service_g8pyld4",   // ← change
        "template_rt8fq4h",  // ← change
        templateParams,
        "j4kqryM_ltebqLlCY"    // ← change
      )
      .then(() => {
        Swal.fire({
          icon: "success",
          title: "Request Submitted!",
          text: "Our team will contact you soon 😊",
          showConfirmButton: false,
          timer: 2500,
        });
        setFormData({
          name: "",
          phone: "",
          email: "",
          message: "",
        });
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Failed to Send!",
          text: "Please try again later.",
        });
      });
  };

  return (
    <section
      id="contact"
      className="contact-section"
      style={{ backgroundImage: `url(${siteData.contactBg})` }}
    >
      <div className="black-overlay"></div>

      <div className="contact-content">
        <h2 className="contact-title">Get In Touch</h2>
        <div className="underline"></div>

        <form className="contact-form" onSubmit={handleSubmit}>
          <label>Name*</label>
          <input
            type="text"
            name="name"
            placeholder="Your Name*"
            required
            value={formData.name}
            onChange={handleChange}
          />

          <label>Mobile*</label>
          <input
            type="tel"
            name="phone"
            placeholder="Mobile No*"
            maxLength="10"
            required
            value={formData.phone}
            onChange={handleChange}
          />

          <label>Email</label>
          <input
            type="email"
            name="email"
            placeholder="Optional"
            value={formData.email}
            onChange={handleChange}
          />

          <label>Message</label>
          <textarea
            name="message"
            placeholder="Optional"
            rows="3"
            value={formData.message}
            onChange={handleChange}
          ></textarea>

          <button type="submit" className="submit-btn">
            REQUEST A CALL BACK
          </button>
        </form>
      </div>
    </section>
  );
}
